import request from '@/utils/request'

// 生存环境

// 获取用户信息
export function getUser (params) {
  return request({
    data: params,
    url: '/old/api/Expert/ById?id='+params.id,
    method: 'get'
  })
}

// 获取成果数据
export function getRes (data) {
  return request({
    data: data,
    url: '/old/api/queryResources',
    method: 'post'
  })
}

// 认领专家
export function claim (data) {
  return request({
    data: data,
    url: '/old/api/Expert/Claim',
    method: 'post'
  })
}

// 保存成果
export function tempclaimdatastore (data) {
  return request({
    data: data,
    url: '/old/api/tempclaimdatastore',
    method: 'post'
  })
}

// 搜索
export function allresource (data) {
  return request({
    data: data,
    url: '/old/api/allresource',
    method: 'post'
  })
}

// 完成成果认领
export function finish (data) {
  return request({
    data: data,
    url: '/old/api/tempclaimdatasearch',
    method: 'post'
  })
}

// 完成成果认领
export function BatchInsert (data) {
  return request({
    data: data,
    url: '/old/api/ExpertResource/BatchInsert',
    method: 'post'
  })
}

// 上传
export function upload (data) {
  return request({
    data: data,
    url: '/old/api/upload',
    method: 'post'
  })
}

// 获取履历
export function getExpM (data) {
  return request({
    data: data,
    url: '/old/api/ExpertResume/Query',
    method: 'post'
  })
}

// 获取成果列表
export function getExpC (data) {
  return request({
    data: data,
    url: '/old/api/ExpertResource/Query',
    method: 'post'
  })
}

// 修改成果列表
export function Update (data) {
  return request({
    data: data,
    url: '/old/api/Expert/Update',
    method: 'post'
  })
}

// 修改履历
export function UpdateM (data) {
  return request({
    data: data,
    url: '/old/api/ExpertResume/Update',
    method: 'post'
  })
}

// 添加 履历
export function addM (data) {
  return request({
    data: data,
    url: '/old/api/ExpertResume/Insert',
    method: 'post'
  })
}

// 添加成果
export function addC (data) {
  return request({
    data: data,
    url: '/old/api/ExpertResource/Insert',
    method: 'post'
  })
}

// 删除履历
export function delM (data) {
  return request({
    data: data,
    url: '/old/api/ExpertResume/Delete',
    method: 'post'
  })
}

// 删除成果
export function delC (data) {
  return request({
    data: data,
    url: '/old/api/ExpertResource/Delete',
    method: 'post'
  })
}

// 合并
export function merge (data) {
  return request({
    data: data,
    url: '/old/api/queryNameOrgArray',
    method: 'post'
  })
}

// 获取新成果
export function newResults (data) {
  return request({
    data: data,
    url: '/old/api/ExpertResource/GetRecommendStat',
    method: 'post'
  })
}
export function getAllCountData (data) {
  return request({
    data: data,
    url: '/old/countdata',
    method: 'post'
  })
}

// 开发环境

// // 获取用户信息
// export function getUser (params) {
//   return request({
//     params: params,
//     url: '/api/api/Expert/ById',
//     method: 'post'
//   })
// }
// // 获取成果数据
// export function getRes (data) {
//   return request({
//     data: data,
//     url: '/api/api/queryResources',
//     method: 'post'
//   })
// }

// // 认领专家
// export function claim (data) {
//   return request({
//     data: data,
//     url: 'api/api/Expert/Claim',
//     method: 'post'
//   })
// }

// // 保存成果
// export function tempclaimdatastore (data) {
//   return request({
//     data: data,
//     url: '/api/api/tempclaimdatastore',
//     method: 'post'
//   })
// }

// // 搜索论文
// export function allresource (data) {
//   return request({
//     data: data,
//     url: '/api/api/allresource',
//     method: 'post'
//   })
// }

// // 完成成果认领
// export function finish (data) {
//   return request({
//     data: data,
//     url: '/api/api/tempclaimdatasearch',
//     method: 'post'
//   })
// }
// // 完成成果认领
// export function BatchInsert (data) {
//   return request({
//     data: data,
//     url: '/api/api/ExpertResource/BatchInsert',
//     method: 'post'
//   })
// }

// // 上传
// export function upload (data) {
//   return request({
//     data: data,
//     url: 'test/api/upload',
//     method: 'post'
//   })
// }

// // 获取成果列表
// export function getExpC (data) {
//   return request({
//     data: data,
//     url: 'api/api/ExpertResource/Query',
//     method: 'post'
//   })
// }

// // 获取履历
// export function getExpM (data) {
//   return request({
//     data: data,
//     url: 'api/api/ExpertResume/Query',
//     method: 'post'
//   })
// }

// // 修改成果列表
// export function Update (data) {
//   return request({
//     data: data,
//     url: '/api/api/Expert/Update',
//     method: 'post'
//   })
// }

// // 修改履历
// export function UpdateM (data) {
//   return request({
//     data: data,
//     url: '/api/api/ExpertResume/Update',
//     method: 'post'
//   })
// }

// // 添加履历
// export function addM (data) {
//   return request({
//     data: data,
//     url: '/api/api/ExpertResume/Insert',
//     method: 'post'
//   })
// }

// // 添加成果
// export function addC (data) {
//   return request({
//     data: data,
//     url: '/api/api/ExpertResource/Insert',
//     method: 'post'

//   })
// }

// // 删除履历
// export function delM (data) {
//   return request({
//     data: data,
//     url: '/api/api/ExpertResume/Delete',
//     method: 'post'
//   })
// }

// // 删除成果
// export function delC (data) {
//   return request({
//     data: data,
//     url: '/api/api/ExpertResource/Delete',
//     method: 'post'
//   })
// }

// // 合并
// export function merge (data) {
//   return request({
//     data: data,
//     url: '/api/api/queryNameOrgArray',
//     method: 'post'
//   })
// }

// // 获取新成果
// export function newResults (data) {
//   return request({
//     data: data,
//     url: 'api/api/ExpertResource/GetRecommendStat',
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/claim.js